import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/**
 * Deep link into the store's published checkout profile, where the Redo
 * shipping-option widget must be switched on by hand.
 */
export const getCheckoutEditorUrl = {
  name: "getCheckoutEditorUrl" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ url: z.string().optional() }),
};
